import { cn } from "@newxsystems/shared";
import { SproutCardLink } from "../SproutCardLink/SproutCardLink";
import { SproutMedia } from "../SproutMedia/SproutMedia";
import { SproutRichText } from "../SproutRichText/SproutRichText";
import type { IImageContentGridTopProps } from "./ImageContentGridTop.props";

const columns = {
  1: "grid-cols-1",
  2: "grid-cols-1 sm:grid-cols-2",
  3: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3",
  4: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
} as const;

export const ImageContentGridTop = ({
  columnCount,
  imageAspectRatio,
  items,
}: IImageContentGridTopProps) => (
  <div className={cn("grid gap-x-6 gap-y-12", columns[columnCount || 3])}>
    {items.map((item, index) => (
      <SproutCardLink
        className={cn(
          "overflow-visible border-0 bg-transparent",
          index % 3 === 0 && "-rotate-[0.6deg]",
          index % 3 === 1 && "rotate-[0.8deg]",
          index % 3 === 2 && "-rotate-[0.35deg]",
        )}
        key={index}
        link={item.cardLink}
      >
        <SproutMedia
          aspectRatio={imageAspectRatio || "16:9"}
          className="sprout-paper-lift rounded-[1.25rem_1.25rem_1.25rem_0.3rem] border-[0.55rem] border-whiteboard"
          imageClassName="transition-transform duration-300 ease-out group-hover:scale-[1.025]"
          media={item.image.image}
          sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
        />
        <div className="mx-3 -mt-1 border-t-4 border-sunflower bg-whiteboard px-3 pt-5 pb-4">
          <h3 className="font-sprout-display text-2xl font-bold leading-tight transition-colors group-hover:text-primary">
            {item.heading}
          </h3>
          {item.description ? (
            <SproutRichText
              className="mt-3 text-base text-basalt md:text-lg"
              content={item.description}
            />
          ) : null}
        </div>
      </SproutCardLink>
    ))}
  </div>
);

ImageContentGridTop.displayName = "Content::ImageContentGridTop";
